// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3zb-k","inputWrap":"CustomTip_inputWrap__3rV9y"};